import React, {useEffect, useRef, useState} from "react";
import axios from '../../services/axiosInstance';
import {BiCaretDown} from "react-icons/bi";
import mailHeader from "../../assets/img/mailInquiry.png";
import {useTranslation} from "react-i18next";
import {useLocation, useNavigate} from "react-router-dom";
import {Helmet} from "react-helmet-async";
import useTheme from "../../components/web/layoutscommon/DarkModeStorage";
import "../../css/web/UserPageRenew.css";

function UserMailInquiryPg() {

    const { t } = useTranslation();
    const location = useLocation();
    const navigate = useNavigate();
    const [theme] = useTheme();

    const [selectedType, setSelectedType] = useState({value: '', label: t('umiLb1')});
    // Footer에서 제휴문의 클릭 시 헤더(제휴/협업)자동지정
    useEffect(() => {
        if (location.state?.selectedType) {
            setSelectedType(location.state.selectedType);
        }
    }, [location.state, t]);

    const [receivedMail, setReceivedMail] = useState('');
    const [orderNumber, setOrderNumber] = useState('');
    const [contentText, setContentText] = useState('');

    const [typeError, setTypeError] = useState(false);
    const [mailError, setMailError] = useState(false);
    const [contentError, setContentError] = useState(false);

    const [isSendBtLoading, setIsSendBtLoading] = useState(false);
    const [sendEmailFail, setSendEmailFail] = useState(false);

    const typeList = [
        {value: "help@btorage.com", label: t('umi1')},
        {value: "help@btorage.com", label: t('umi2')},
        {value: "help@btorage.com", label: t('umi3')},
        {value: "help@btorage.com", label: t('umi4')},
        {value: "help@btorage.com", label: t('umi5')},
        {value: "help@btorage.com", label: t('umi6')},
        {value: "help@btorage.com", label: t('umi7')},
        {value: "help@btorage.com", label: t('umi8')},
        {value: "help@btorage.com", label: t('umi9')},
        {value: "help@btorage.com", label: t('umi10')}
    ]

    const [typeShow, setTypeShow] = useState(false);
    const typeRef = useRef(null);

    const toggleCountryShow = () => {
        setTypeShow(!typeShow);
    };

    const handleTypeChange = (type) => {
        setSelectedType(type);
        setTypeError(false);
        setTypeShow(false);
    };

    useEffect(() => {
        function handleClickOutside(event) {
            if (typeRef.current && !typeRef.current.contains(event.target)) {
                setTypeShow(false);
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleEmailChange = (e) => {
        setMailError(false);
        setReceivedMail(e.target.value);
    };

    const handleOrdNumChange = (e) => {
        setOrderNumber(e.target.value);
    };

    const handleContentChange = (e) => {
        setContentError(false);
        setContentText(e.target.value);
    };

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    const validation = (() => {
        if (!selectedType.value || selectedType.label === t('umiLb1')) {
            setTypeError(true);
            return false;
        }
        if (!receivedMail || !emailRegex.test(receivedMail)) {
            setMailError(true);
            return false;
        }
        if (!contentText) {
            setContentError(true);
            return false;
        }
        return true;
    })

    const sendEmail = (() => {
        setIsSendBtLoading(true);
        if (validation()) {
            axios({
                method: 'post',
                url: '/member/mailInquiry/',
                data: {
                    type: selectedType.label,
                    helperMail: selectedType.value,
                    receivedMail: receivedMail,
                    orderNumber: orderNumber,
                    content: contentText
                }
            })
                .then((response) => {
                    navigate("/UserMailSendComplPg");
                })
                .catch((error) => {
                    setIsSendBtLoading(false);
                    setSendEmailFail(true);
                    setTimeout(() => setSendEmailFail(false), 2000);
                    console.log("전송실패 : ", error)
                })
        } else {
            setIsSendBtLoading(false);
        }
    })
    // 실무게&가로&세로&높이 모두 입력될때만 DB에 전송하여 조회

    return (
        <div className="up-scope up-page" data-theme={theme}>

            <Helmet>
                <title>1:1 문의(Non-login inquiry)</title>
                <meta name="description" content="메일문의 및 실시간채팅으로 문의주세요"/>
                <link rel="canonical" href="https://btorage.com/UserMailInquiryPg"/>
                <meta property="og:url" content="https://btorage.com/UserMailInquiryPg"/>
                <link rel="alternate" hrefLang="ko" href="https://btorage.com/UserMailInquiryPg"/>
                <link rel="alternate" hrefLang="x-default" href="https://btorage.com/UserMailInquiryPg"/>

                <link rel="icon" type="image/png" sizes="32x32" href="/bt_logo.png"/>
                <link rel="apple-touch-icon" href="/bt_logo.png"/>
                <meta property="og:type" content="website"/>
                <meta property="og:image" content="https://btorage.com/linkBanner.jpg"/>
                <meta property="og:image:width" content="1200"/>
                <meta property="og:image:height" content="630"/>
                <meta property="og:site_name" content="비토리지(Btorage)"/>
                <meta name="twitter:card" content="summary_large_image"/>
                <meta name="twitter:image" content="https://btorage.com/linkBanner.jpg"/>
            </Helmet>

            <div className="up-form-card">
                <div className="up-form-head">
                    <img className="up-invert" src={mailHeader} alt="header"/>
                    <p className="t">{t('umiHd1')}</p>
                </div>

                <div className="up-card" style={{padding: "28px 26px"}}>
                    {/*문의유형 커스텀 셀렉트*/}
                    <div className="up-field" ref={typeRef} style={{position: "relative"}}>
                        <button className="selectParentBt" style={{width: "100%", height: "48px"}}
                                onClick={toggleCountryShow}>
                            <p style={{overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"}}>{selectedType.label}</p>
                            <span style={{marginLeft: "auto", display: "flex", alignItems: "center", color: "var(--up-text-faint)"}}>
                                <BiCaretDown/>
                            </span>
                        </button>
                        {typeShow ?
                            <div className="up-select-pop up-select-list" style={{
                                position: "absolute", width: "100%", marginTop: "6px", zIndex: 5
                            }}>
                                {typeList.map((type, index) => (
                                    <div className="selectChildBt" key={index}
                                         onClick={() => handleTypeChange(type)} style={{
                                        display: "flex", padding: "11px", justifyContent: "center",
                                        alignItems: "center", cursor: "pointer", fontSize: "14px"
                                    }}>{type.label}</div>
                                ))}
                            </div>
                            :
                            null
                        }
                    </div>
                    {typeError &&
                        <div className="up-err">{t('umiErr1')}</div>
                    }

                    {/*수신이메일*/}
                    <div className="up-field">
                        <input onChange={(e) => handleEmailChange(e)} type="text" className="up-input"
                               placeholder={t('umiPlaceHd1')} value={receivedMail}/>
                    </div>
                    {mailError &&
                        <div className="up-err">{t('umiErr2')}</div>
                    }

                    {/*주문서번호(선택)*/}
                    <div className="up-field">
                        <input onChange={(e) => handleOrdNumChange(e)} type="text" className="up-input"
                               placeholder={t('umiPlaceHd2')} value={orderNumber}/>
                    </div>

                    {/*내용*/}
                    <div className="up-field">
                        <textarea
                            className="up-textarea"
                            placeholder={t('umiPlaceHd3')}
                            spellCheck="false"
                            value={contentText}
                            maxLength={10000}
                            style={{height: "230px"}}
                            onChange={(e) => handleContentChange(e)}/>
                    </div>
                    {contentError &&
                        <div className="up-err">{t('umiErr3')}</div>
                    }

                    {/*버튼*/}
                    <button onClick={sendEmail} className="up-btn-primary" style={{width: "100%", height: "48px", fontSize: "15px", marginTop: "6px"}}>
                        {isSendBtLoading ? (
                            <div className="up-spin"></div>
                        ) : (
                            <span>{t('umiBt1')}</span>
                        )}
                    </button>
                    {sendEmailFail &&
                        <div className="up-err" style={{textAlign: "center", marginTop: "10px"}}>{t('umiErr4')}! &#128514;</div>
                    }
                </div>
            </div>
        </div>
    )
}

export default UserMailInquiryPg
